import { api as neopaymentApi } from './auto-generated/neopayment'

neopaymentApi.enhanceEndpoints({
  endpoints: {},
})

export { neopaymentApi }
